import {
  CheckUpPropertyMeasurement,
  ECheckUpPropertyTypes,
  ECheckUpPropertyUnits,
  ECheckUpSensitivityParams,
  ECheckUpSimulationParams
} from '~/interfaces'

const EMPTY_MEASUREMENT_TEXT = 'N/A'

const CHECK_UP_YEARS_QUANTITY = 4

const defaultCheckUpRequestParams = {
  sensitivity: ECheckUpSensitivityParams.MEDIUM,
  simulation: ECheckUpSimulationParams.NONE
}

const sensitivityFilterOptions = [
  { label: '90%', value: ECheckUpSensitivityParams.HIGH, id: '90%' },
  { label: '80%', value: ECheckUpSensitivityParams.MEDIUM, id: '80%' },
  { label: '70%', value: ECheckUpSensitivityParams.LOW, id: '70%' }
]

const simulationFilterOptions = [
  { label: 'Nenhum', value: ECheckUpSimulationParams.NONE, id: 'none' },
  { label: 'IPAQ Maior', value: ECheckUpSimulationParams.HIGHER_IPAQ, id: 'higher-ipaq' },
  { label: 'IMC Menor', value: ECheckUpSimulationParams.LOWER_IMC, id: 'lower-imc' },
  { label: 'Ambos', value: ECheckUpSimulationParams.BOTH, id: 'both' }
]

const EMPTY_MEASUREMENT: CheckUpPropertyMeasurement = {
  date: '',
  type: ECheckUpPropertyTypes.METABOLIC_SYNDROME,
  simulationResult: undefined,
  unit: ECheckUpPropertyUnits.NONE,
  value: EMPTY_MEASUREMENT_TEXT,
  isAltered: false
}

export {
  defaultCheckUpRequestParams,
  simulationFilterOptions,
  sensitivityFilterOptions,
  CHECK_UP_YEARS_QUANTITY,
  EMPTY_MEASUREMENT_TEXT,
  EMPTY_MEASUREMENT
}
